// Toolbar item registry - maps string keys to components
import { BoldButton } from './BoldButton';
import { BulletListButton } from './BulletListButton';
import { LinkButton } from './LinkButton';
import { HeadingSelector } from './HeadingSelector';
import { Separator } from './Separator';
import { TextColorButton } from './TextColorButton';

export type ToolbarItemType =
  | 'HeadingSelector'
  | 'Bold'
  | 'BulletList'
  | 'Link'
  | 'TextColor'
  | 'Separator';

export const TOOLBAR_ITEMS_REGISTRY: Record<ToolbarItemType, React.ComponentType> = {
  HeadingSelector: HeadingSelector,
  Bold: BoldButton,
  BulletList: BulletListButton,
  Link: LinkButton,
  TextColor: TextColorButton,
  Separator: Separator,
};

// Default toolbar configuration
export const DEFAULT_TOOLBAR_ITEMS: ToolbarItemType[] = [
  'HeadingSelector',
  'Separator',
  'Bold',
  'BulletList',
  'Link',
];
